import VideoEmbed from '../../simple/video-embed/video-embed';
import Testimonials from '../../section/testimonials/testimonials';
import Modal from '../../simple/modal/modal';
import KeyAnnouncement from '../../section/key-announcement/key-announcement';
import Carousel from '../../dynamic/carousel/carousel';
import ScrollTop from '../../simple/scroll-top/scroll-top';
import SearchBar from '../../simple/search-bar/search-bar';
import Accordion from '../../dynamic/accordion/accordion';
import HeaderNav from '../../dynamic/header-nav/header-nav';
import Header from '../../section/header/header';
import ResponsiveTables from '../../base/02-content/responsiveTable';
import Content from '../../base/02-content/content';

//used for class to class interactions
let mainClasses = {
  Accordion,
  Carousel,
  Content,
  Header,
  HeaderNav,
  KeyAnnouncement,
  Modal,
  ResponsiveTables,
  ScrollTop,
  SearchBar,
  Testimonials,
  VideoEmbed,
};

function init() {
  //used for class to class interactions
  let mainClassesInstances = {};

  for (const [key, value] of Object.entries(mainClasses)) {
    try {
      mainClassesInstances[key] = new value();
    } catch (err) {
      console.error('Failed to initialize component: ' + key, err);
    }
  }

  window.KB = {
    mainClasses,
    mainClassesInstances,
  };
}

document.addEventListener('DOMContentLoaded', init);

export default mainClasses;
